import Navbar from './components/Navbar';
import Hero from './components/Hero';
import Services from './components/Services';
import CaseStudies from './components/CaseStudies';
import Features from './components/Features';
import ContactCTA from './components/ContactCTA';
import Footer from './components/Footer';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-slate-950">
      <Navbar />
      <Hero />
      <Services />
      <CaseStudies />
      <Features />
      <ContactCTA />
      <Footer />
    </div>
  );
}
